module.exports = __webpack_public_path__ + "static/media/helaosu.0fcc7d70.png";